"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lib = require("react-bootstrap/lib");

var _chartDataPropTypes = require("../../chartDataPropTypes.js");

var _FilterOption = _interopRequireDefault(require("./FilterOption.js"));

var _lodash = require("lodash");

var _CategoryCheckboxes = _interopRequireDefault(require("./CategoryCheckboxes.js"));

var _utils = require("../../../utils.js");

var _uncontrollable = require("uncontrollable");

var _this = void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var buttonUnsetStyles = {
  textTransform: "unset",
  letterSpacing: "unset",
  height: "unset"
};

var navTabs = function navTabs(className) {
  return function (_ref) {
    var allTabs = _ref.allTabs,
        _ref$disabledTabs = _ref.disabledTabs,
        disabledTabs = _ref$disabledTabs === void 0 ? [] : _ref$disabledTabs,
        currentTab = _ref.currentTab,
        onChangeCurrentTab = _ref.onChangeCurrentTab;

    // Beware: we’re using a custom nav class, it’s just the same as Bootstrap’s but renamed to avoid clashes with
    // other environments where nav is also used
    var _style = className === "pills" ? {
      fontSize: "medium",
      "float": "right"
    } : {
      fontSize: "medium"
    };

    var classStyle = className === "pills" ? "columns small-2 gxa-nav" : "gxa-nav";
    return /*#__PURE__*/_react["default"].createElement(_lib.Nav, {
      bsClass: classStyle,
      bsStyle: className,
      activeKey: currentTab,
      onSelect: onChangeCurrentTab,
      style: _style
    }, allTabs.map(function (tab) {
      return /*#__PURE__*/_react["default"].createElement(_lib.NavItem, {
        eventKey: tab,
        key: tab,
        disabled: disabledTabs.includes(tab)
      }, tab);
    }));
  };
};

var topRibbonTabs = navTabs("tabs");
var categoryTabs = navTabs("pills");

var _FiltersModal = function _FiltersModal(_ref2) {
  var showModal = _ref2.showModal,
      onCloseModal = _ref2.onCloseModal,
      allTopTabs = _ref2.tabNames,
      currentTopTab = _ref2.currentTopTab,
      onChangeCurrentTopTab = _ref2.onChangeCurrentTopTab,
      categories = _ref2.categories,
      categoryCheckboxes = _ref2.categoryCheckboxes,
      currentValues = _ref2.currentValues,
      allValues = _ref2.allValues,
      _onChangeCurrentValues = _ref2.onChangeCurrentValues;
  return /*#__PURE__*/_react["default"].createElement(_lib.Modal, {
    show: showModal,
    onHide: onCloseModal,
    bsSize: "large",
    style: {
      opacity: 0.95
    }
  }, /*#__PURE__*/_react["default"].createElement(_lib.Modal.Header, {
    closeButton: true
  }, allTopTabs.length > 1 ? topRibbonTabs({
    allTabs: allTopTabs,
    currentTab: currentTopTab,
    onChangeCurrentTab: onChangeCurrentTopTab
  }) : /*#__PURE__*/_react["default"].createElement("h4", {
    className: "modal-title"
  }, " Filters ")), /*#__PURE__*/_react["default"].createElement(_lib.Modal.Body, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement(_CategoryCheckboxes["default"], {
    categories: categoryCheckboxes,
    allValues: allValues,
    currentValues: currentValues,
    currentTab: (categories.find(function (category) {
      return allValues.every(function (value) {
        return currentValues.some(function (currentValue) {
          return currentValue.value === value.value;
        }) === value.categories.includes(category.name);
      }) && !category.disabled;
    }) || {
      name: ""
    }).name,
    onChangeCurrentValues: _onChangeCurrentValues
  }), categoryTabs({
    allTabs: categories.map(function (c) {
      return c.name;
    }),
    disabledTabs: categories.filter(function (c) {
      return c.disabled;
    }).map(function (c) {
      return c.name;
    }),
    currentTab: (categories.find(function (category) {
      return allValues.every(function (value) {
        return currentValues.some(function (currentValue) {
          return currentValue.value === value.value;
        }) === value.categories.includes(category.name);
      }) && !category.disabled;
    }) || {
      name: ""
    }).name,
    onChangeCurrentTab: function onChangeCurrentTab(categoryName) {
      return _onChangeCurrentValues(allValues.filter(function (e) {
        return e.categories.includes(categoryName);
      }));
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginLeft: "20px",
      columnCount: "2"
    }
  }, (0, _lodash.sortBy)((0, _utils.groupIntoPairs)([].concat.apply([], allValues.map(function (v) {
    return (v.groupings.find(function (g) {
      return g.name === currentTopTab;
    }) || {
      values: []
    }).values.map(function (group) {
      return [group.label, v.value];
    });
  })), "0").map(function (a) {
    return [a[0], [].concat.apply([], a[1].map(function (aa) {
      return aa[1];
    }))];
  }), function (a) {
    return a[0] === "Unmapped" ? "_" : " ".concat(a[0]);
  } //makes Unmapped go last
  ).map(function (a) {
    return /*#__PURE__*/_react["default"].createElement(_FilterOption["default"], {
      key: a[0],
      name: a[0],
      allValues: a[1],
      currentValues: a[1].filter(function (v) {
        return currentValues.some(function (c) {
          return c.value === v;
        });
      }),
      onChangeCurrentValues: function onChangeCurrentValues(newCurrentValues) {
        return _onChangeCurrentValues(allValues.filter(function (v) {
          return a[1].includes(v.value) ? newCurrentValues.includes(v.value) : currentValues.some(function (c) {
            return c.value === v.value;
          });
        }));
      }
    });
  }))), /*#__PURE__*/_react["default"].createElement(_lib.Modal.Footer, null, /*#__PURE__*/_react["default"].createElement(_lib.Button, {
    onClick: onCloseModal,
    style: buttonUnsetStyles
  }, "Close")));
};

var FiltersModal = (0, _uncontrollable.uncontrollable)(_FiltersModal, {
  currentTopTab: "onChangeCurrentTopTab"
});

var FiltersButton = function FiltersButton(_ref3) {
  var disabled = _ref3.disabled,
      onClickButton = _ref3.onClickButton;
  return /*#__PURE__*/_react["default"].createElement(_lib.Button, {
    bsSize: "small",
    onClick: onClickButton,
    disabled: disabled,
    title: disabled ? "Reset zoom to enable filters" : "",
    style: buttonUnsetStyles
  }, /*#__PURE__*/_react["default"].createElement(_lib.Glyphicon, {
    glyph: "equalizer"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      verticalAlign: "middle"
    }
  }, " Filters"));
};

var _Main = function _Main(props) {
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(FiltersButton, _extends({}, props, {
    onClickButton: props.onChangeShowModal.bind(_this, true)
  })), /*#__PURE__*/_react["default"].createElement(FiltersModal, _extends({}, props, {
    onCloseModal: props.onChangeShowModal.bind(_this, false),
    defaultCurrentTopTab: props.tabNames[0] || "",
    defaultCurrentCategory: props.categories.find(function (c) {
      return !c.disabled;
    })
  })));
};

_Main.propTypes = {
  categories: _propTypes["default"].arrayOf(_chartDataPropTypes.columnCategoryPropTypes).isRequired,
  categoryCheckboxes: _propTypes["default"].arrayOf(_chartDataPropTypes.columnCategoryPropTypes).isRequired,
  allValues: _propTypes["default"].arrayOf(_chartDataPropTypes.groupedColumnPropTypes).isRequired,
  currentValues: _propTypes["default"].arrayOf(_chartDataPropTypes.groupedColumnPropTypes).isRequired,
  disabled: _propTypes["default"].bool.isRequired,
  onChangeCurrentValues: _propTypes["default"].func.isRequired,
  tabNames: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  onChangeShowModal: _propTypes["default"].func.isRequired,
  showModal: _propTypes["default"].bool.isRequired
};
var Main = (0, _uncontrollable.uncontrollable)(_Main, {
  showModal: "onChangeShowModal"
});
Main.defaultProps = {
  defaultShowModal: false
};
var _default = Main;
exports["default"] = _default;